import React, { useState } from 'react';
import './main.css';

function Main() {
  const [language, setLanguage] = useState('en');

  const t = {
    en: {
      name: 'Your Full Name',
      role: 'Software Developer | Full-Stack Engineer | Tech Enthusiast',
      aboutTitle: 'About Me',
      aboutText:
        "I'm a passionate software developer with a focus on building elegant, scalable web applications.",
      skillsTitle: 'Skills',
      experienceTitle: 'Experience',
      job1Title: 'Customer Success Manager — [Company Name]',
      job1Dates: '2022 - Present',
      job1Text:
        'Managing software rollouts, client onboarding, and product optimization strategies.',
      job2Title: 'Software Developer — Freelance',
      job2Dates: '2020 - 2022',
      job2Text:
        'Built and deployed full-stack web applications for small businesses and startups.',
      contactTitle: 'Contact',
      email: 'Email',
      linkedin: 'LinkedIn',
      github: 'GitHub',
      switchLang: 'Deutsch',
    },
    
    de: {
      name: 'Ihr vollständiger Name',
      role: 'Softwareentwickler | Full-Stack Engineer | Technikbegeistert',
      aboutTitle: 'Über mich',
      aboutText:
        'Ich bin ein leidenschaftlicher Softwareentwickler mit Fokus auf elegante, skalierbare Webanwendungen.',
      skillsTitle: 'Fähigkeiten',
      experienceTitle: 'Erfahrung',
      job1Title: 'Customer Success Manager — [Firmenname]',
      job1Dates: '2022 - Heute',
      job1Text:
        'Verantwortlich für Software-Einführungen, Kunden-Onboarding und Produktoptimierung.',
      job2Title: 'Softwareentwickler — Freiberuflich',
      job2Dates: '2020 - 2022',
      job2Text:
        'Entwicklung und Bereitstellung von Full-Stack-Webanwendungen für kleine Unternehmen und Startups.',
      contactTitle: 'Kontakt',
      email: 'E-Mail',
      linkedin: 'LinkedIn',
      github: 'GitHub',
      switchLang: 'English',
    },
  };

  const lang = t[language];

  return (
    <div className="cv-container">
      <div className="lang-toggle">
        <button onClick={() => setLanguage(language === 'en' ? 'de' : 'en')}>
          {lang.switchLang}
        </button>
      </div>

      <header className="cv-header">
        <h1>{lang.name}</h1>
        <p>{lang.role}</p>
      </header>

      <section className="cv-section">
        <h2>{lang.aboutTitle}</h2>
        <p>{lang.aboutText}</p>
      </section>

      <section className="cv-section">
        <h2>{lang.skillsTitle}</h2>
        <ul className="cv-list">
          <li>React</li>
          <li>Django</li>
          <li>JavaScript / TypeScript</li>
          <li>Python</li>
          <li>REST APIs</li>
          <li>PostgreSQL</li>
          <li>Git & GitHub</li>
          <li>Docker</li>
        </ul>
      </section>

      <section className="cv-section">
        <h2>{lang.experienceTitle}</h2>
        <div className="cv-job">
          <h3>{lang.job1Title}</h3>
          <p className="cv-dates">{lang.job1Dates}</p>
          <p>{lang.job1Text}</p>
        </div>
        <div className="cv-job">
          <h3>{lang.job2Title}</h3>
          <p className="cv-dates">{lang.job2Dates}</p>
          <p>{lang.job2Text}</p>
        </div>
      </section>

      <section className="cv-section">
        <h2>{lang.contactTitle}</h2>
        <p>{lang.email}: your.email@example.com</p>
        <p>{lang.linkedin}: <a href="https://linkedin.com/in/yourprofile" target="_blank" rel="noreferrer">linkedin.com/in/yourprofile</a></p>
        <p>{lang.github}: <a href="https://github.com/yourusername" target="_blank" rel="noreferrer">github.com/yourusername</a></p>
      </section>
    </div>
  );
}

export default Main;
